import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ADD_SUBDISTRICT, DISTRICTS_SEARCH, LANGUAGES_SEARCH } from "helpers/api_endpoints";
import GoogleMapReact from 'google-map-react';
import MapComponent from "../../components/Common/Map"
import Select from "react-select";


//meta title
document.title = "Add Sub District";

const AddSubDistrict = () => {

	const [name, setName] = useState('');
	const [districts, setDistricts] = useState([]);
	const [districtId, setDistrictId] = useState('');
	const [symbol, setSymbol] = useState('');
	const [status, setStatus] = useState(0);
	const [boundries, setBoundries] = useState([
		{ lat: 24.712186535213522, lng: 55.11976906855254 },
		{ lat: 24.712186535213522, lng: 55.23976906855254 },
		{ lat: 24.882186535213522, lng: 55.23976906855254 },
		{ lat: 24.882186535213522, lng: 55.11976906855254 }
		]);
    const [valued, setValued] = useState({"title":[]});
	const [languages, setLanguages] = useState([]);
	const [errorMsg, seterrorMsg] = useState('');
	const navigate = useNavigate();

	const defaultProps = {
		center: {
			lat: 24.42702779066894,
			lng: 54.45959945677776
		},
		zoom: 11
		};

	useEffect(() => {
		// successMessage();
		post(`${DISTRICTS_SEARCH}`)
			.then(response => {
				const data = response.data.map((el,index)=>{
					return {value:el.id,label:el.named.title[0]['1']}; 
				});
				setDistricts(data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
				if (error.response.status == 400) {
					navigate('/logout');
				}
			})
	}, []);

	useEffect(() => {
		post(`${LANGUAGES_SEARCH}`,{status:1})
			.then(response => {
				setLanguages(response.data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
			})
	}, []);

	const handleSubmit = () => {
		post(ADD_SUBDISTRICT, { name, districtId, symbol, status, boundries })
			.then(response => {
				if (response.code == 201) {
					navigate('/sub-districts', { state: { successMsg: 'Sub District Added SuccessFully' } });
				}
			})
			.catch(error => {
				seterrorMsg('Sub District Creation Failed');
			})
	}

	const Marker = ({ text }) => <div>{text}</div>;
	const handleApiLoaded = ({map, maps}) => {

	}

    const handleName = (languageId,value) => {
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }
	const handleFilter = (type,value) => {
		switch(type)
		{
			case 'districtId':
				{
					setDistrictId(value);
					break;
				}
            case 'name':
                {
                    break;
                }
			default:
				break;
		}

	}

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs title="Sub Districts" breadcrumbItem="Add Sub District" />
					<Form
						className="form-horizontal"
						onSubmit={(e) => {
							e.preventDefault();
							handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										<Row>
											{errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
											{
												languages.map((language, index) => (
													<Row key={index}>
													<div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            // value={name}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
												</Row>
                                                ))
											}
											
											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>District</Trans></Label>
												<Select
													name="districtId"
													options={districts} 
													className="form-control select2"
													onChange={(e) => handleFilter('districtId', e.value)}
													required
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Symbol</Trans></Label>
												<Input
													name="symbol"
													// value={name}
													className="form-control"
													placeholder="Enter Symbol"
													type="text"
													onChange={(e) => setSymbol(e.target.value)} 
													required
												></Input>
											</div>


											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Status</Trans></Label>
												<select className="form-control" onChange={(e) => setStatus(e.target.value)} required>
													<option value=''></option>
													<option value={1} selected={status == 1}><Trans>Active</Trans></option>
													<option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
												</select>
											</div>

										</Row>
										<div className="text-center  mt-4">
											<Button type="submit" color="danger">
												<Trans>Submit</Trans>
											</Button>
										</div>
									</CardBody>
									<CardBody>
										<Row>
											<div className="form-group col-md-12 mt-2" >
												<Label className="form-label"><Trans>Map</Trans></Label>
												<MapComponent boundries={boundries} setBoundries={setBoundries} />
											</div>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col xl={12}>
								<Row>

								</Row>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
	)
}

export default AddSubDistrict
